export default "__VITE_ASSET__BbLUTEpJ__"